import Image from "next/image";
import registry from "@/data/media-secmhy.json";
type Media = {
  src: string;
  alt: string;
  caption: string;
  width: number;
  height: number;
};
export default function AssetFrame({
  assetKey,
  label = "",
  className = "",
}: {
  assetKey: string;
  label?: string;
  className?: string;
}) {
  const media = (registry as Record<string, Media>)[assetKey];
  return (
    <figure className={`asset-frame ${className}`}>
      <div className="asset-window">
        {media ? (
          <Image
            priority={assetKey === "hero"}
            src={media.src}
            alt={media.alt}
            width={media.width}
            height={media.height}
            sizes="(max-width:700px) 100vw, 50vw"
          />
        ) : (
          <span className="asset-empty">{label || "Photographie SECMHY"}</span>
        )}
      </div>
      {media?.caption && <figcaption>{media.caption}</figcaption>}
    </figure>
  );
}
